import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import {
  formatCompactCurrency,
  getTradeRatiosOverview,
} from '../../common/utils/backtestSummaryStats'

// Beyond this many ratios the dots crowd the footer; a proportion bar takes their place.
const MAX_RATIO_DOTS = 12

// Backtest-wide view across every tested ratio: how many were profitable and how far apart they landed.
function BacktestRatiosOverview({ summaries }: { summaries: any[] }) {
  const { total, profitableCount, minProfit, maxProfit } = getTradeRatiosOverview(summaries)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25, minWidth: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        {total <= MAX_RATIO_DOTS ? (
          <Box sx={{ display: 'flex', gap: 0.375, flexShrink: 0 }} aria-hidden>
            {summaries.map((summary: any) => (
              <Box
                key={summary.group}
                sx={{
                  width: 7,
                  height: 7,
                  borderRadius: '50%',
                  backgroundColor: (summary.currentProfit || 0) > 0 ? 'primary.main' : 'error.main',
                }}
              />
            ))}
          </Box>
        ) : (
          <Box
            aria-hidden
            sx={{
              display: 'flex',
              width: 48,
              height: 6,
              flexShrink: 0,
              borderRadius: 999,
              overflow: 'hidden',
              backgroundColor: 'error.main',
            }}
          >
            <Box
              sx={{ width: `${(profitableCount / total) * 100}%`, backgroundColor: 'primary.main' }}
            />
          </Box>
        )}
        <Typography variant="caption" color="text.secondary" noWrap>
          <Box component="b" sx={{ color: 'text.primary' }}>
            {profitableCount}/{total}
          </Box>{' '}
          ratios profitable
        </Typography>
      </Box>
      {total > 1 && (
        <Typography variant="caption" color="text.secondary" noWrap sx={{ fontSize: 11 }}>
          P&L across ratios {formatCompactCurrency(minProfit)} – {formatCompactCurrency(maxProfit)}
        </Typography>
      )}
    </Box>
  )
}

export default BacktestRatiosOverview
